import { useTranslation } from "translation/useTranslation";

export default function ListPagination({ page, perPage, totalPages, totalRows, setPage, setPerPage, testIdPrefix = "", className = "mt-3" }) {
  const { editableTranslate } = useTranslation();

  const handleChangePage = (e, target) => {
    e.preventDefault();
    if (target >= 1 && target <= totalPages) setPage(target);
  };

  const handleChangePerPage = (e) => {
    setPerPage(+e.target.value);
  };

  const pageItem = (n) => (
    <li key={n}>
      <a
        className={`peb-pagination__page ${page === n ? 'peb-pagination__page--active' : ''}`}
        href="/#"
        aria-current={page === n ? 'page' : undefined}
        onClick={(e) => handleChangePage(e, n)}
        data-testid={`${testIdPrefix}pagination-page-${n}`}
      >
        {n}
      </a>
    </li>
  );

  const renderPages = () => {
    const data = [pageItem(1)];

    let start = 2;
    let end = totalPages - 1;

    if (totalPages > 11) {
      if (page >= 7) {
        start = page - 4;
        end = page + 4;
        if (end > totalPages - 1) {
          end = totalPages - 1;
          start = end - 9;
        }
      } else {
        end = 10;
      }
    }

    if (start > 2) data.push(<li key="start-dot" className="peb-pagination__gap">…</li>);
    for (let i = start; i <= end; i++) data.push(pageItem(i));
    if (totalPages - end > 1) data.push(<li key="end-dot" className="peb-pagination__gap">…</li>);

    if (totalPages > 1) data.push(pageItem(totalPages));

    return data;
  };

  if (totalPages <= 1 && totalRows <= 20) return null;

  return (
    <div className={`peb-pagination ${className}`} data-testid={`${testIdPrefix}pagination`}>
      <nav>
        {
          totalPages > 1 && (
            <ul className="peb-pagination__pages">
              <li>
                <a
                  className={`peb-pagination__page peb-pagination__page--step ${page === 1 ? 'peb-pagination__page--disabled' : ''}`}
                  href="/#"
                  aria-label="Previous"
                  onClick={(e) => handleChangePage(e, page === 1 ? 1 : page - 1)}
                  data-testid={`${testIdPrefix}pagination-prev`}
                >
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              {renderPages()}
              <li>
                <a
                  className={`peb-pagination__page peb-pagination__page--step ${page === totalPages ? 'peb-pagination__page--disabled' : ''}`}
                  href="/#"
                  aria-label="Next"
                  onClick={(e) => handleChangePage(e, page === totalPages ? totalPages : page + 1)}
                  data-testid={`${testIdPrefix}pagination-next`}
                >
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          )
        }
      </nav>

      {
        totalRows > 20 && (
          <div className="peb-pagination__size">
            <span>{editableTranslate('global.per_page', 'Pro Seite')}:</span>
            <select className="peb-pagination__size-select" value={perPage} onChange={handleChangePerPage} data-testid={`${testIdPrefix}pagination-page-size`}>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>
        )
      }
    </div>
  );
}
